export default "__VITE_ASSET__0R4bDRf4__"